export default __webpack_public_path__ + "static/media/statya56.96870b94.pdf";